<template>
  <div>
    <a-card
      style="width:100%"
      :tabList="tabListNoTitle"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-if="noTitleKey === 'release'">
        <a-form
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item
            label="标题"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              v-decorator="[
                'note',
                {rules: [{ required: true, message: '请输入标题!' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
            label="类型"
          >
            <a-radio-group
              v-decorator="['type',
                            {rules: [{ required: true, message: '请选择推送类型!' }]}]">
              <a-radio value="1" >
                公告
              </a-radio>
              <a-radio value="2">
                通知
              </a-radio>
              <a-radio value="3">
                提醒
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
            label="接收人">
            <div class="receiver-right">
              已选择{{ nameList.length }}人 <span @click="pushMessage({},1)">重新选择</span>
              <div class="receiver-people">
                <span v-for=" item in nameList" >{{ item }} ; </span>
              </div>
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
            class="quill-editor"
            label="内容">
            <quill-editor
              v-model="content"
              ref="myQuillEditor"
              :options="editorOption"
              @change="onEditorChange"
            >
            </quill-editor>
          </a-form-item>
          <a-form-item
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
            label="上传附件">
            <a-upload
              name="img"
              :action="uploadUrl"
              :remove="removeFile"
              @change="handleImgChange">
              <a-button>
                <a-icon type="upload" /> 文件上传
              </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 12, offset: 2 }"
          >
            <a-button
              type="primary"
              html-type="submit"
            >
              提交
            </a-button>
          </a-form-item>
        </a-form>
<!--        <div class="receiver-sele">-->
<!--          <div class="receiver-left">-->
<!--            接收人：-->
<!--          </div>-->
<!--          <div class="receiver-right">-->
<!--            已选择{{ nameList.length }}人 <span @click="pushMessage({},1)">重新选择</span>-->
<!--            <div class="receiver-people">-->
<!--              <span v-for=" item in nameList" >{{ item }} ; </span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="receiver">-->
<!--          <div class="receiver-left">-->
<!--            内容：-->
<!--          </div>-->
<!--          <div class="receiver-right">-->
<!--            <quill-editor-->
<!--              v-model="content"-->
<!--              class="quill-editor"-->
<!--              ref="myQuillEditor"-->
<!--              :options="editorOption"-->
<!--              @change="onEditorChange"-->
<!--            >-->
<!--            </quill-editor>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div v-else="noTitleKey === 'list'">
        <div class="search">
          <a-select
            defaultValue="0"
            style="width: 240px;margin-right:60px"
            @change="handleChange"
            placeholder="选择分类"
          >
            <a-select-option value="0">全部</a-select-option>
            <a-select-option value="1">公告</a-select-option>
            <a-select-option value="2">通知</a-select-option>
            <a-select-option value="3">提醒</a-select-option>
          </a-select>
          <a-input-search placeholder="搜索文章" @search="onSearch" style="width: 500px" enterButton/>
        </div>

        <a-table :columns="columns" :dataSource="noticeList" rowKey="id" :pagination="page" @change="TableChange">
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="pushMessage(record,2)">推送</a-button>&nbsp;&nbsp;
            <a-button type="primary" :ghost="true" @click="showedit(record)">编辑</a-button>&nbsp;&nbsp;
            <a-button type="danger" @click="deleteMessage(record.id)">删除</a-button>
          </div>
        </a-table>
      </div>
      <push-message ref="showPushMessage" @ok="handleName"/>
      <edit-notice ref="creatNotice" @ok="handOk"/>
    </a-card>
  </div>
</template>

<script>
// 文章操作表格
import '../../../node_modules/quill/dist/quill.core.css'
import '../../../node_modules/quill/dist/quill.snow.css'
import '../../../node_modules/quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import PushMessage from './PushMessage'
import EditNotice from './editNotice'
import api from '@/api/manage'
import { baseUrl } from '@/utils/request'
import { NoticeList, addNewsNotice, deleteAnnouncement } from '@/api/manage'

const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id'
}, {
  title: '标题',
  dataIndex: 'title',
  key: 'title'
}, {
  title: '分类',
  dataIndex: 'type',
  key: 'type'
}, {
  title: '作者',
  dataIndex: 'creator',
  key: 'creator'
}, {
  title: '发布时间',
  dataIndex: 'create_time',
  key: 'create_time'
}, {
  title: '操作',
  dataIndex: 'action',
  width: '20%',
  scopedSlots: { customRender: 'action' }
}]

export default {
  components: {
    quillEditor,
    PushMessage,
    EditNotice
  },
  data () {
    return {
      tabListNoTitle: [{
        key: 'release',
        tab: '发布公告'
      }, {
        key: 'list',
        tab: '公告列表'
      }],
      noTitleKey: 'release',
      // 公告发布form
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      seleValue: 0, // 下拉框的value
      // 富文本数据
      content: '',
      // contentHtml:'',
      editorOption: {
        // some quill options
      },
      nameList: [], // 抄送人员名单
      seleId: [], // 选中的id集合
      // 列表数据
      noticeList: [],
      columns,
      // 分页
      page: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      loading: false,
      uploading: false,
      uploadUrl: baseUrl + api.uploadUrl,
      fileList: [],
      filePath: '',
      filePathArr: []
    }
  },
  methods: {
    handleImgChange (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.filePathArr = [...this.filePathArr, info.file.response.result.full_path]
        // console.log(this.filePathArr)
        this.loading = false
      }
      if (info.file.status === 'error') {
        this.$message.error(info.file.response.msg)
        this.loading = false
      }
    },
    removeFile (file) {
      this.filePathArr.forEach((item, index) => {
        item === file.response.result.full_path ? this.filePathArr.splice(index, 1) : ''
      })
    },
    onTabChange (key, type) {
      // console.log(key, type)
      this[type] = key
      if (key === 'list') {
        this.getNoticeList({ page: 1, pageSize: 10, type: 0, title: '' })
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      if (!this.nameList || !this.content) {
        this.$message.error('请完善信息')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.filePathArr ? this.filePath = this.filePathArr.join(',') : this.filePath = ''
          this.addNotice({ title: values.note, type: values.type, content: this.content, file_path: this.filePath, user_ids: this.seleId.join(',') })
          // console.log('Received values of form: ', values)
        }
      })
    },
    pushMessage (record, type) {
      this.$refs.showPushMessage.show(record, type)
    },
    showedit (record) {
      this.$refs.creatNotice.show(record)
    },
    handleName (seleId, nameList) {
      this.seleId = JSON.parse(seleId)
      this.nameList = JSON.parse(nameList)
    },
    handOk () {
      this.getNoticeList({ page: this.page.current, pageSize: 10, type: this.seleValue, title: '' })
    },
    addNotice (parmas) {
      // console.log(parmas)
      return addNewsNotice(parmas)
        .then(res => {
          this.$message.success(res.msg)
          this.content = ''
          this.nameList = []
          this.seleId = []
          this.form.resetFields()
          this.onTabChange('list', 'noTitleKey')
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    onEditorChange ({ quill, html, text }) {
      this.content = html
    },
    getNoticeList (parma) {
      return NoticeList(parma)
        .then(res => {
          this.noticeList = res.result.list
          this.noticeList.forEach((item) => {
            if (item.type === 1) {
              item.type = '公告'
            } else if (item.type === 2) {
              item.type = '通知'
            } else {
              item.type = '提醒'
            }
          })
          this.page.total = res.result.total
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // 下拉框
    handleChange (value) {
      this.seleValue = value
      this.getNoticeList({ page: 1, pageSize: 10, type: value, title: '' })
    },
    // 搜索框搜索的内容
    onSearch (value) {
      this.getNoticeList({ page: this.page.current, pageSize: 10, type: this.seleValue, title: value })
    },
    TableChange (pagination) {
      this.page.current = pagination.current
      this.getNoticeList({ page: pagination.current, pageSize: 10, type: this.seleValue, title: '' })
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    deleteMessage (id) {
      // console.log(id)
      this.$confirm({
        title: '确定删除当前公告?',
        content: '',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.loading = true
          // 删除公告的请求接口
          return deleteAnnouncement({
            id: id
          })
            .then(res => {
              this.$message.success(res.msg)
              this.getNoticeList({ page: this.page.current, pageSize: 10, type: this.seleValue, title: '' })
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.loading = false
            })
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    }
  }
}
</script>

<style scoped>
  /*.receiver-left {*/
  /*  width: 8%;*/
  /*  display: inline-block;*/
  /*  text-align: right;*/
  /*  vertical-align: top;*/
  /*}*/

  .receiver-right {
    margin-left: 5px;
    width: 80%;
    display: inline-block;
  }
  /*.receiver {*/
  /*  min-height: 500px;*/
  /*  margin-bottom: 60px;*/
  /*}*/
  /*  .receiver-sele {*/
  /*  min-height: 10px;*/
  /*  margin-bottom: 20px;*/
  /*}*/
  .receiver-right > span {
    color: skyblue;
    cursor: pointer;
  }

  .quill-editor {
    width: 100%;
    height: 400px;
    margin-bottom: 100px;
  }
  .btn {
    /*  position: absolute;*/
    /*  top: 90%;*/
    /*  left: 10%;*/
  }
  .search {
    margin-bottom: 40px;
  }
  /*.ant-card-wider-padding {*/
  /*  min-height: 1000px;*/
  /*}*/
  /*.upload_file {*/
  /*  position: absolute;*/
  /*  top: 76%;*/
  /*  left: 10%;*/
  /*}*/
</style>
